/* eslint-disable */
import { Box, Card, GlobalStyles, Menu, styled } from "@mui/material";
import { height } from "@mui/system";

export const ContentEditSectionWrapper = styled("section")(({ theme }) => ({
  minHeight: "calc(100vh - 70px)",
  backgroundColor: theme.palette.background.default,
  paddingBottom: "60px",
  "& .ContentEditWrapper": {
    "& .jodit-react-container": {
      "& .jodit-container": {
        backgroundColor: "transparent",
        border: `1px solid ${theme.palette.divider}`,
        "& .jodit-toolbar__box": {
          position: "sticky",
          borderBottom: "none",
          top: "70px",
          backgroundColor: theme.palette.background.default,
          zIndex: "1000",
          width: "100%",
          "@media screen and (max-width:1200px)": {
            top: "64px",
          },
          "@media screen and (max-width:600px)": {
            top: "59px",
          },
          "& .jodit-icon": {
            stroke: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
            fill: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
          },
          "& .jodit-toolbar-button__button": {
            "&:hover:not([disabled])": {
              backgroundColor: theme.palette.primary.main + "2b",
            },
          },
          "& .jodit-toolbar-button__trigger": {
            "& svg": { fill: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547" },
            "&:hover:not([disabled])": {
              backgroundColor: theme.palette.primary.main + "2b",
            },
          },
          "&:not(:empty)": {
            "& .jodit-toolbar-editor-collection": {
              "&:after": {
                backgroundColor: theme.palette.divider,
              },
            },
          },
          "& .jodit-toolbar-editor-collection_mode_horizontal": { backgroundImage: `repeating-linear-gradient(transparent 0, transparent 37px, ${theme.palette.divider} 38px)` },
        },
        "& .jodit-workplace": {
          backgroundColor: "transparent",
          minHeight: "415px !important",
          "& .jodit-wysiwyg": {
            minHeight: "415px !important",
            "& *": {
              wordBreak: "break-word",
              color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
            },
            "& a, a *": {
              color: theme.palette.primary.main,
            },
          },
          "& .jodit-source": {
            backgroundColor: theme.palette.primary.main + "08",
            "& textarea": {
              backgroundColor: "transparent",
              color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
            },
          },
        },
        "& .jodit-status-bar": {
          backgroundColor: "transparent",
          "& .jodit-status-bar__item": {
            "& *": {
              color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
            },
            "& a": {
              "&[href='https://xdsoft.net/jodit/']": {
                display: "none",
              },
            },
          },
        },
        "& .jodit-workplace+.jodit-status-bar:not(:empty)": {
          borderTop: `1px solid ${theme.palette.divider}`,
        },
        "& .jodit-add-new-line": {
          display: "none",
        },
      },
    },
  },
  "& .ScoreAndFilterWrapper": {
    "& .GraphWrapper": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderBottom: "1px solid" + theme.palette.divider,
      "@media screen and (max-width: 600px)": {
        flexDirection: "column-reverse",
        gap: "12px",
      },
      "& .BudgeWrapper": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "2px",
        padding: "6px 8px 6px",
        borderRadius: "6px",
        backgroundColor: theme.palette.primary.main + "2b",
        "& svg": { color: theme.palette.primary.main },
        "& h3": {
          color: theme.palette.primary.main,
          fontSize: "20px",
          fontWeight: 600,
          lineHeight: 1,
        },
      },
    },
    "& .ProgressScoreWrapper": {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      alignItems: "center",
      gap: "20px",
      rowGap: "15px",
      paddingTop: "12px",
      "& .ProgressBlockWrapper": {
        width: "calc(50% - 10px)",
        "& p": {
          fontSize: "12px",
          fontWeight: 600,
          color: theme.palette.mode === "dark" ? "#ffffff" : "#959AA3",
          marginBottom: "8px",
          lineHeight: 1,
          "& span": {
            fontSize: "12px",
            fontWeight: 700,
            color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
            lineHeight: 1,
          },
        },
        "& .ProgressWrapper": {
          width: "100%",
          height: "8px",
          borderRadius: "50px",
          backgroundColor: "#EEEEEE",
          overflow: "hidden",
          "& .ProgressInner": {
            height: "8px",
            borderRadius: "50px",
            backgroundColor: "#5CBB76",
          },
        },
      },
    },
  },
  "& .ScoreFilterDetailWrapper": {
    "& .TabMainWrapper": {
      "& .TabLabelWrapper": {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        "& .MuiTabs-root": {
          minHeight: "auto",
          "& .MuiTabs-flexContainer": {
            gap: "20px",
            "& button": {
              padding: "0",
              minWidth: "auto",
              minHeight: "auto",
              height: "auto",
              fontSize: "14px",
              fontWeight: 700,
              paddingBottom: "4px",
              "&:focus": {
                outline: "none",
              },
            },
          },
        },
        "& .FilterBtn": {
          "&:focus": {
            outline: "none",
          },
        },
      },
    },
  },
}));


export const StepperWrapper = styled(Box)(({ theme }) => ({
  "& .MuiStepper-root": {
    "& .MuiStep-root": {
      display: "flex",
      alignItems: "center",
      gap: "20px",
      "@media screen and (max-width:600px)": {
        gap: "5px",
        paddingLeft: "4px",
        paddingRight: "4px",
      },
      "& .MuiStepLabel-root": {
        "& .MuiStepLabel-labelContainer": {
          "& .MuiStepLabel-label": {
            fontSize: "14px",
            fontWeight: "500",
            color: theme.palette.primary.main,
            "@media screen and (max-width:600px)": {
              fontSize: "11px",
            },
          },
        },
        "&.Mui-disabled": {
          "& .MuiStepLabel-labelContainer": {
            "& .MuiStepLabel-label": {
              color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
            },
          },
        },
      },
      "& .RightArrow": {
        color: theme.palette.primary.main,
        fontSize: "15px",
      },
      "& .Mui-disabled": {
        "& + .RightArrow": {
          color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
        },
      },
    },
  },
  "& .BodyWrapper": {},
  "& .FooterWrapper": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "10px",
    "@media screen and (max-width:600px)": {
      flexDirection: "column",
      alignItems: "stretch",
    },
    "& button": {
      textTransform: "none",
      backgroundColor: theme.palette.primary.main,
      color: "#ffffff",
      borderRadius: "5px",
      boxShadow: "none",
      padding: "6px 22px",
      gap: "8px",
      "@media screen and (max-width:600px)": {
        width: "100%",
        padding: "6px 16px",
      },
      "&:focus": {
        outline: "0",
      },
      "&.Mui-disabled": {
        opacity: "0.5",
      },
    },
  },
}));
export const ContentBriefWrapper = styled(Box)(({ theme }) => ({
  paddingTop: "32px",
  paddingBottom: "32px",
  "& .TopFormWrapper": {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: "20px",
    marginBottom: "20px",
    "@media screen and (max-width:600px)": {
      minHeight: "30px !important",
      maxHeight: "30px !important",
      // flexDirection: "column",
      // alignItems: "stretch",
    },
    "& .BasicInput": {
      flex: "1",
      "& label": {
        color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
        fontSize: "14px",
        fontWeight: 500,
        lineHeight: 1,
        marginBottom: "12px",
        "& button": {
          gap: "7px",
          lineHeight: 1,
          padding: "5px 10px 5px",
          marginTop: "-10px",
          marginLeft: "8px",
          marginBottom: "-7px",
          "& svg": { fontSize: "14px" },
        },
      },
      "& .MuiFormControl-root": {
        "& .MuiInputBase-root": {
          "& input": {
            fontSize: "14px",
            fontWeight: 700,
            backgroundColor: theme.palette.mode === "dark" ? "#d8dbe1" : "#EAEBED",
            color: "#2A3547",
            padding: "6px 14px 6px 14px",
            minHeight: "30px",
            borderRadius: "7px",
            maxWidth: "100%",
            "&::-webkit-input-placeholder": {
              color: "#7f7f7f",
              opacity: "1",
            },
          },
          "& fieldset": {
            display: "none",
          },
        },
      },
    },
    "& .BasicDropDown": {
      flex: "1",
      "& label": {
        color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
        fontSize: "14px",
        fontWeight: 500,
        lineHeight: 1,
        marginBottom: "12px",
      },
      "& .MuiInputBase-root": {
        "& .MuiSelect-select": {
          fontSize: "14px",
          fontWeight: 700,
          backgroundColor: theme.palette.mode === "dark" ? "#d8dbe1" : "#EAEBED",
          color: "#2A3547",
          padding: "6px 38px 6px 14px",
          minHeight: "30px",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        },
        "& [data-testid='ExpandMoreIcon']": {
          color: "#2A3547",
          fontSize: "28px",
        },
        "& fieldset": { display: "none" },
      },
    },
  },
  "& .BasicTextarea": {
    width: "100%",
    "& label": {
      color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: 1,
      marginBottom: "12px",
    },
    "& .MuiFormControl-root": {
      "& .MuiInputBase-root": {
        padding: "0px",
        "& textarea": {
          width: "100%",
          fontSize: "14px",
          fontWeight: 700,
          backgroundColor: theme.palette.mode === "dark" ? "#d8dbe1" : "#EAEBED",
          color: "#2A3547",
          padding: "10px 14px 10px 14px",
          minHeight: "30px",
          borderRadius: "7px",
          maxWidth: "100%",
          "&::-webkit-input-placeholder": {
            color: "#7f7f7f",
            opacity: "1",
          },
        },
        "& fieldset": {
          display: "none",
        },
      },
    },
  },
}));
export const ArticleOutlineWrapper = styled(Box)(({ theme }) => ({ // changes made in the height and scrollbar styles
  paddingTop: "6px",
  paddingBottom: "6px",
  "& .jodit-react-container": {
    "& .jodit-container": {
      backgroundColor: "transparent",
      border: `1px solid ${theme.palette.divider}`,
      "& .jodit-toolbar__box": {
        position: "sticky",
        borderBottom: "none",
        top: "70px",
        backgroundColor: theme.palette.background.default,
        zIndex: "1000",
        width: "100%",
        "@media screen and (max-width:1200px)": {
          top: "64px",
        },
        "@media screen and (max-width:600px)": {
          top: "59px",
        },
        "& .jodit-icon": {
          stroke: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
          fill: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
        },
        "& .jodit-toolbar-button__button": {
          "&:hover:not([disabled])": {
            backgroundColor: theme.palette.primary.main + "2b",
          },
        },
        "& .jodit-toolbar-button__trigger": {
          "& svg": { fill: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547" },
          "&:hover:not([disabled])": {
            backgroundColor: theme.palette.primary.main + "2b",
          },
        },
        "&:not(:empty)": {
          "& .jodit-toolbar-editor-collection": {
            "&:after": {
              backgroundColor: theme.palette.divider,
            },
          },
        },
        "& .jodit-toolbar-editor-collection_mode_horizontal": { backgroundImage: `repeating-linear-gradient(transparent 0, transparent 37px, ${theme.palette.divider} 38px)` },
      },
      "& .jodit-workplace": {
        backgroundColor: "transparent",
        minHeight: "250px !important",
        maxHeight: "250px !important",
        "@media screen and (max-width:600px)": {
          minHeight: "200px !important",
          maxHeight: "200px !important",
        },
        "& .jodit-wysiwyg": {
          minHeight: "250px !important",
          "@media screen and (max-width:600px)": {
            minHeight: "200px !important",
          },
          "&::-webkit-scrollbar-track": {
            borderRadius: "30px",
            backgroundColor: theme.palette.text.primary + "0d",
          },
          "&::-webkit-scrollbar": { width: "4px", backgroundColor: "transparent" },
          "&::-webkit-scrollbar-thumb": {
            borderRadius: "10px",
            WebkitBoxShadow: "inset 0 0 6px rgba(0,0,0,.3)",
            backgroundColor: theme.palette.primary.main,
          },
          "& h1": { fontSize: "25px !important" },
          "& h2": { fontSize: "20px !important" },
          "& h3": { fontSize: "15px !important" },
          "& *": {
            wordBreak: "break-word",
            color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
          },
          "& a, a *": {
            color: theme.palette.primary.main,
          },
        },
        "& .jodit-source": {
          backgroundColor: theme.palette.primary.main + "08",
          "& textarea": {
            backgroundColor: "transparent",
            color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
          },
        },
      },
      "& .jodit-status-bar": {
        backgroundColor: "transparent",
        "& .jodit-status-bar__item": {
          "& *": {
            color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
          },
          "& a": {
            "&[href='https://xdsoft.net/jodit/']": {
              display: "none",
            },
          },
        },
      },
      "& .jodit-workplace+.jodit-status-bar:not(:empty)": {
        borderTop: `1px solid ${theme.palette.divider}`,
      },
      "& .jodit-add-new-line": {
        display: "none",
      },
    },
  },
}));
export const ArticleContentWrapper = styled(Box)(({ theme }) => ({
  paddingTop: "3px",
  paddingBottom: "5px",
  "& .ContentWrapper": {  // changes made in the height and scrollbar styles
    minHeight: "310px !important",
    maxHeight: "310px !important",
    overflow: "auto",
    "@media screen and (max-width:600px)": {
      minHeight: "264px !important",
      maxHeight: "264px !important",
    },
    "&::-webkit-scrollbar-track": {
      borderRadius: "10px",
      backgroundColor: theme.palette.text.primary + "0d",
    },
    "&::-webkit-scrollbar": { width: "4px", backgroundColor: "transparent" },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "10px",
      WebkitBoxShadow: "inset 0 0 6px rgba(0,0,0,.3)",
      backgroundColor: theme.palette.primary.main,
    },
    "& > *": {
      color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
      "&:first-child": { marginTop: "0" },
    },
    "& h1": {
      fontSize: "25px",
      marginTop: "40px",
      marginBottom: "25px",
    },
    "& h2": {
      fontSize: "20px",
      marginTop: "40px",
      marginBottom: "25px",
    },
    "& h3": {
      fontSize: "15px",
      marginTop: "40px",
      marginBottom: "25px",
    },
  },
}));
export const ArticleOutlineJoditGlobalStyles = ({ theme }) => (
  <GlobalStyles
    styles={{
      "&.jodit-dialog": {
        "& .jodit-dialog__panel": {
          backgroundColor: theme.palette.background.default,
          border: `2px solid ${theme.palette.divider}`,
          minWidth: "430px",
          minHeight: "210px",
          width: "500px",
          borderRadius: "6px",
          [theme.breakpoints.down("600px")]: {
            width: "90%",
          },
          "& .jodit-dialog__header": {
            borderBottom: `1px solid ${theme.palette.divider}`,
            "& .jodit-dialog__header-title": {
              fontSize: "22px",
              color: theme.palette.text.primary,
              fontWeight: 600,
            },
          },
          "& .jodit-dialog__content": {
            "& form": {
              "& label": {
                fontSize: "16px",
                color: theme.palette.text.primary,
              },
            },
          },
          "& .jodit-dialog__footer": {
            gap: "10px",
            "& button": {
              flex: "1",
              backgroundColor: theme.palette.primary.main + "2b",
              color: theme.palette.primary.main,
              borderRadius: "5px",
              marginRight: "0",
              whiteSpace: "nowrap",
              padding: "0",
              "&.jodit-ui-button_keep": {
                backgroundColor: theme.palette.primary.main,
                color: "#ffffff",
              },
            },
          },
        },
        "& *": {
          fontFamily: "'Plus Jakarta Sans', sans-serif !important",
        },
      },
      "&.jodit.jodit-popup-container": {
        "& .jodit-popup": {
          boxShadow: "none",
          "& .jodit-popup__content": {
            backgroundColor: theme.palette.background.default,
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: "6px",
            "&::-webkit-scrollbar-track": {
              WebkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.3)",
              borderRadius: "10px",
              backgroundColor: theme.palette.background.default,
            },
            "&::-webkit-scrollbar": { width: "5px", backgroundColor: "transparent" },
            "&::-webkit-scrollbar-thumb": {
              borderRadius: "10px",
              WebkitBoxShadow: "inset 0 0 6px rgba(0,0,0,.3)",
              backgroundColor: theme.palette.primary.main,
            },
            "& .jodit-tabs": {
              "& .jodit-tabs__wrapper": {
                "& form": {
                  marginBottom: "0",
                  "& .jodit-ui-input__label": {
                    color: theme.palette.text.primary,
                  },
                  "& .jodit-ui-input__wrapper": {
                    backgroundColor: "transparent",
                    border: "none",
                    "& input": {
                      backgroundColor: theme.palette.background.default,
                      border: `1px solid ${theme.palette.divider}`,
                      borderRadius: "3px",
                      color: theme.palette.text.primary,
                    },
                  },
                  "& button": {
                    "&.jodit-ui-button": {
                      backgroundColor: theme.palette.primary.main,
                      color: "#ffffff",
                      borderRadius: "5px",
                      whiteSpace: "nowrap",
                    },
                  },
                },
              },
            },
            "& .jodit-toolbar-editor-collection": {
              "& span": {
                "&.jodit-toolbar-button": {
                  display: "none",
                  "&.jodit-ui-group__h1,&.jodit-ui-group__h2,&.jodit-ui-group__h3": {
                    display: "block",
                    "& span": { fontSize: "28px" },
                  },
                  "& button": {
                    color: theme.palette.text.primary,
                    "& pre": {
                      color: theme.palette.text.primary,
                    },
                    "&:hover": {
                      color: "#2A3547",
                      "& pre": {
                        color: "#2A3547",
                      },
                    },
                  },
                },
              },
            },
            "& form": {
              "&.jodit-ui-form": {
                marginBottom: "0",
                "& .jodit-ui-input": {
                  "& .jodit-ui-input__label": {
                    color: theme.palette.text.primary,
                  },
                  "& .jodit-ui-input__wrapper": {
                    backgroundColor: "transparent",
                    border: "none",
                    "& input": {
                      backgroundColor: theme.palette.background.default,
                      border: `1px solid ${theme.palette.divider}`,
                      borderRadius: "3px",
                      color: theme.palette.text.primary,
                    },
                  },
                },
                "& .jodit-ui-checkbox": {
                  color: theme.palette.text.primary,
                },
                "& button": {
                  "&.jodit-ui-button": {
                    backgroundColor: theme.palette.primary.main,
                    color: "#ffffff",
                    borderRadius: "5px",
                    whiteSpace: "nowrap",
                  },
                },
              },
            },
          },
        },
        "& *": {
          fontFamily: "'Plus Jakarta Sans', sans-serif !important",
        },
      },
    }}
  />
);
export const ArticleDetailStyle = styled(Box)(({ theme }) => ({
  "& .DropDownWrapper": {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "6px",
    flexWrap: "wrap",
    padding: "18px 0px 18px",
    "& .FilledDropDown": {
      "& button": {
        width: "auto",
        fontSize: "14px",
        fontWeight: 700,
        backgroundColor: theme.palette.primary.main + "2b",
        color: theme.palette.primary.main,
        padding: "6px 14px 6px 14px",
        minHeight: "42px",
        display: "flex",
        alignItems: "center",
        gap: "8px",
        "&:focus": {
          outline: "0",
        },
        "&.Mui-disabled": {
          opacity: "0.5",
        },
        "& .ExpandMoreIcon": {
          color: theme.palette.primary.main,
          fontSize: "28px",
        },
      },
    },
    "& .BasicDropDown": {
      "& .MuiInputBase-root": {
        "& .MuiSelect-select": {
          width: "auto",
          fontSize: "14px",
          fontWeight: 700,
          backgroundColor: "#EAEBED",
          color: "#2A3547",
          padding: "6px 38px 6px 14px",
          minHeight: "30px",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          "& .ColorBox": {
            width: "18px",
            height: "18px",
            borderRadius: "50px",
            border: `1px solid ${theme.palette.mode === "dark" ? "#ffffff" : "#2A3547"}`,
          },
        },
        "& [data-testid='ExpandMoreIcon']": {
          color: "#2A3547",
          fontSize: "28px",
        },
        "& fieldset": { display: "none" },
      },
    },
    "& .BasicMenuDropDown": {
      "& button": {
        width: "auto",
        fontSize: "14px",
        fontWeight: 700,
        backgroundColor: "#EAEBED",
        color: "#2A3547",
        padding: "6px 14px 6px 14px",
        minHeight: "42px",
        display: "flex",
        alignItems: "center",
        gap: "8px",
        "&:focus": {
          outline: "0",
        },
        "&.Mui-disabled": {
          opacity: "0.5",
        },
        "& .ExpandMoreIcon": {
          color: "#2A3547",
          fontSize: "28px",
        },
      },
    },
    "& .BasicInput": {
      "& .MuiFormControl-root": {
        "& .MuiInputBase-root": {
          "& input": {
            width: "auto",
            fontSize: "14px",
            fontWeight: 700,
            backgroundColor: "#EAEBED",
            color: "#2A3547",
            padding: "6px 14px 6px 14px",
            minHeight: "30px",
            borderRadius: "7px",
            maxWidth: "120px",
            "&::-webkit-input-placeholder": {
              color: "#2A3547",
              opacity: "1",
            },
          },
          "& fieldset": {
            display: "none",
          },
        },
      },
    },
  },
  "& .GeneratedListWrapper": {
    "& .MainBlockWrapper": {
      padding: "8px 0px 15px",
      borderBottom: "1px solid" + theme.palette.divider,
      "&:last-of-type": {
        borderBottom: "none",
        padding: "8px 0px 0px",
      },
      "& .BlockHeadWrapper": {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: "5px",
        fontSize: "14px",
        fontWeight: 700,
        marginBottom: "6px",
        "& .InfoIcon": { color: "#959AA3", fontSize: "18px" },
        "& .CopyIcon": { fontSize: "18px", color: theme.palette.primary.main, cursor: "pointer" },
        "& .DownArrow": { fontSize: "28px", color: theme.palette.primary.main, cursor: "pointer" },
      },
      "& .ListBlockWrapper": {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: "8px",
        flexWrap: "wrap",
        maxHeight: "200px",
        overflowY: "auto",
        "&::-webkit-scrollbar-track": {
          borderRadius: "10px",
          backgroundColor: theme.palette.text.primary + "0d",
        },
        "&::-webkit-scrollbar": { width: "8px", backgroundColor: "transparent" },
        "&::-webkit-scrollbar-thumb": {
          borderRadius: "10px",
          WebkitBoxShadow: "inset 0 0 6px rgba(0,0,0,.3)",
          backgroundColor: theme.palette.primary.main,
        },
        "& .ListInnerWrapper": {
          "& p": {
            fontSize: "14px",
            fontWeight: 600,
            lineHeight: 1,
            padding: "5px 5px 5px 10px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            borderRadius: "4px",
            "& span": {
              backgroundColor: theme.palette.mode === "dark" ? "#ffffffbf" : "#ffffff",
              lineHeight: 1,
              padding: "5px 6px 4px",
              borderRadius: "3px",
              color: "#2A3547",
              fontSize: "14px",
              fontWeight: 600,
              whiteSpace: "nowrap",
            },
          },
          "&.Red": {
            "& p": { backgroundColor: "#e83d6224", color: "#E83D62" },
          },
          "&.Yellow": { "& p": { backgroundColor: "#DB951924", color: "#DB9519" } },
          "&.Green": { "& p": { backgroundColor: "#3BB54A24", color: "#3BB54A" } },
          "&.Black": { "& p": { backgroundColor: theme.palette.mode === "dark" ? "#ffffff24" : "#2A354724", color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547" } },
        },
      },
    },
  },
}));
export const ContentEditHeaderStyle = styled(Card)(({ theme }) => ({
  padding: "16px 16px 16px 16px",
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: "none !important",
  "& .ContentWrapper": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "15px",
    marginBottom: "20px",
    "@media screen and (max-width:730px)": {
      flexDirection: "column",
      alignItems: "stretch",
    },
    "& h2": {
      color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
      lineHeight: 1,
      fontWeight: 700,
      fontSize: "24px",
      marginBottom: "8px",
    },
    "& h3": {
      color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
      lineHeight: "20px",
      fontWeight: 500,
      fontSize: "16px",
    },
    "& .BtnWrapper": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "8px",
      "@media screen and (max-width:600px)": {
        flexDirection: "column",
        alignItems: "stretch",
      },
      "& button": {
        textTransform: "none",
        backgroundColor: theme.palette.primary.main,
        color: "#ffffff",
        borderRadius: "5px",
        boxShadow: "none",
        padding: "6px 22px",
        gap: "8px",
        "@media screen and (max-width:600px)": {
          width: "100%",
          padding: "6px 16px",
        },
        "&:focus": {
          outline: "0",
        },
      },
    },
  },
  "& .FormWrapper": {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    gap: "10px",
    "& .BasicInput": {
      width: "100%",
      "& label": {
        color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
        fontSize: "14px",
        fontWeight: 500,
        lineHeight: 1,
        marginBottom: "12px",
        "& button": {
          gap: "7px",
          lineHeight: 1,
          padding: "5px 10px 5px",
          marginTop: "-10px",
          marginLeft: "8px",
          marginBottom: "-7px",
          "& svg": { fontSize: "14px" },
        },
      },
      "& .MuiFormControl-root": {
        "& .MuiInputBase-root": {
          "& input": {
            fontSize: "14px",
            fontWeight: 700,
            backgroundColor: theme.palette.mode === "dark" ? "#afb2b8" : "#EAEBED",
            color: "#2A3547",
            padding: "6px 14px 6px 14px",
            minHeight: "30px",
            borderRadius: "7px",
            maxWidth: "100%",
            "&::-webkit-input-placeholder": {
              color: "#7f7f7f",
              opacity: "1",
            },
          },
          "& fieldset": {
            display: "none",
          },
        },
      },
    },
    "& .SaveBtn": {
      textTransform: "none",
      backgroundColor: theme.palette.primary.main,
      color: "#ffffff",
      borderRadius: "5px",
      boxShadow: "none",
      padding: "6px 22px",
      gap: "8px",
      minHeight: "42px",
      "@media screen and (max-width:600px)": {
        padding: "6px 16px",
      },
      "&:focus": {
        outline: "0",
      },
    },
  },
}));
export const ContentGeneratePopupStyle = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  maxWidth: "1200px",
  backgroundColor: theme.palette.background.default,
  border: `2px solid ${theme.palette.divider}`,
  borderRadius: "6px",
  padding: "25px 25px 25px",
  "@media screen and (max-width:1200px)": {
    width: "90%",
    padding: "40px 25px 25px",
  },
  "& .closeBtn": {
    width: "24px",
    height: "24px",
    backgroundColor: "transparent",
    padding: "10px !important",
    position: "absolute",
    top: "12px",
    right: "12px",
    minWidth: "0",
    "&:focus": {
      border: "none",
      outline: "none",
    },
    "&:hover": {
      backgroundColor: "transparent",
      color: "#fff",
      "& svg": {
        fill: theme.palette.primary.main,
      },
    },
  },
  "& .BodyContentWrapper": {},
}));
export const ContentEditJoditGlobalStyles = ({ theme }) => (
  <GlobalStyles
    styles={{
      "&.jodit-dialog": {
        "& .jodit-dialog__panel": {
          backgroundColor: theme.palette.background.default,
          border: `2px solid ${theme.palette.divider}`,
          minWidth: "430px",
          minHeight: "210px",
          width: "500px",
          borderRadius: "6px",
          [theme.breakpoints.down("600px")]: {
            width: "90%",
          },
          "& .jodit-dialog__header": {
            borderBottom: `1px solid ${theme.palette.divider}`,
            "& .jodit-dialog__header-title": {
              fontSize: "22px",
              color: theme.palette.text.primary,
              fontWeight: 600,
            },
          },
          "& .jodit-dialog__content": {
            "& form": {
              "& label": {
                fontSize: "16px",
                color: theme.palette.text.primary,
              },
            },
          },
          "& .jodit-dialog__footer": {
            gap: "10px",
            "& button": {
              flex: "1",
              backgroundColor: theme.palette.primary.main + "2b",
              color: theme.palette.primary.main,
              borderRadius: "5px",
              marginRight: "0",
              whiteSpace: "nowrap",
              padding: "0",
              "&.jodit-ui-button_keep": {
                backgroundColor: theme.palette.primary.main,
                color: "#ffffff",
              },
            },
          },
        },
        "& *": {
          fontFamily: "'Plus Jakarta Sans', sans-serif !important",
        },
      },
      "&.jodit.jodit-popup-container": {
        "& .jodit-popup": {
          boxShadow: "none",
          "& .jodit-popup__content": {
            backgroundColor: theme.palette.background.default,
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: "6px",
            "&::-webkit-scrollbar-track": {
              WebkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.3)",
              borderRadius: "10px",
              backgroundColor: theme.palette.background.default,
            },
            "&::-webkit-scrollbar": { width: "5px", backgroundColor: "transparent" },
            "&::-webkit-scrollbar-thumb": {
              borderRadius: "10px",
              WebkitBoxShadow: "inset 0 0 6px rgba(0,0,0,.3)",
              backgroundColor: theme.palette.primary.main,
            },
            "& .jodit-tabs": {
              "& .jodit-tabs__wrapper": {
                "& form": {
                  marginBottom: "0",
                  "& .jodit-ui-input__label": {
                    color: theme.palette.text.primary,
                  },
                  "& .jodit-ui-input__wrapper": {
                    backgroundColor: "transparent",
                    border: "none",
                    "& input": {
                      backgroundColor: theme.palette.background.default,
                      border: `1px solid ${theme.palette.divider}`,
                      borderRadius: "3px",
                      color: theme.palette.text.primary,
                    },
                  },
                  "& button": {
                    "&.jodit-ui-button": {
                      backgroundColor: theme.palette.primary.main,
                      color: "#ffffff",
                      borderRadius: "5px",
                      whiteSpace: "nowrap",
                    },
                  },
                },
              },
            },
            "& .jodit-toolbar-editor-collection": {
              "& span": {
                "&.jodit-toolbar-button": {
                  "& button": {
                    color: theme.palette.text.primary,
                    "& pre": {
                      color: theme.palette.text.primary,
                    },
                    "&:hover": {
                      color: "#2A3547",
                      "& pre": {
                        color: "#2A3547",
                      },
                    },
                  },
                },
              },
            },
            "& form": {
              "&.jodit-ui-form": {
                marginBottom: "0",
                "& .jodit-ui-input": {
                  "& .jodit-ui-input__label": {
                    color: theme.palette.text.primary,
                  },
                  "& .jodit-ui-input__wrapper": {
                    backgroundColor: "transparent",
                    border: "none",
                    "& input": {
                      backgroundColor: theme.palette.background.default,
                      border: `1px solid ${theme.palette.divider}`,
                      borderRadius: "3px",
                      color: theme.palette.text.primary,
                    },
                  },
                },
                "& .jodit-ui-checkbox": {
                  color: theme.palette.text.primary,
                },
                "& button": {
                  "&.jodit-ui-button": {
                    backgroundColor: theme.palette.primary.main,
                    color: "#ffffff",
                    borderRadius: "5px",
                    whiteSpace: "nowrap",
                  },
                },
              },
            },
          },
        },
        "& *": {
          fontFamily: "'Plus Jakarta Sans', sans-serif !important",
        },
      },
    }}
  />
);
export const ImportMenuWrapper = styled(props => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 150,
    "& .MuiMenu-list": {
      padding: "0px 0px",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        marginRight: "12px",
      },
    },
  },
}));
export const ImportRawHtmlPopupStyle = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  height: "80vh",
  width: "100%",
  maxWidth: "800px",
  backgroundColor: theme.palette.background.default,
  border: `2px solid ${theme.palette.divider}`,
  borderRadius: "6px",
  padding: "25px 25px 25px",
  "@media screen and (max-width:1200px)": {
    width: "90%",
    padding: "40px 15px 20px",
  },
  "& .closeBtn": {
    width: "24px",
    height: "24px",
    backgroundColor: "transparent",
    padding: "10px !important",
    position: "absolute",
    top: "12px",
    right: "12px",
    minWidth: "0",
    "&:focus": {
      border: "none",
      outline: "none",
    },
    "&:hover": {
      backgroundColor: "transparent",
      color: "#fff",
      "& svg": {
        fill: theme.palette.primary.main,
      },
    },
  },
  "& .BodyContentWrapper": {
    "& h2": {
      color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
      lineHeight: "25px",
      fontWeight: 500,
      fontSize: "18px",
      marginBottom: "25px",
    },
    "& textarea": {
      color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
      width: "100%",
      resize: "vertical",
      height: "55vh",
      padding: "12px 16px 16px 16px",
      border: `1px solid ${theme.palette.divider}`,
      boxShadow: "none !important",
      borderRadius: "6px",
      background: theme.palette.primary.main + "0a",
      overflowY: "auto",   // important
      "&:focus-visible": { outline: "none" },
      "&::-webkit-scrollbar": { width: "6px", backgroundColor: "transparent" },
      "&::-webkit-scrollbar-track": { borderRadius: "10px", backgroundColor: theme.palette.text.primary + "0d" },
      "&::-webkit-scrollbar-thumb": { borderRadius: "10px", backgroundColor: theme.palette.primary.main, WebkitBoxShadow: "inset 0 0 6px rgba(0,0,0,.3)" },

    },
    "& .BtnWrapper": {
      marginTop: "20px",
      textAlign: "right",
      "& button": {
        textTransform: "none",
        backgroundColor: theme.palette.primary.main,
        color: "#ffffff",
        borderRadius: "5px",
        boxShadow: "none",
        padding: "8px 16px",
        gap: "8px",
        minWidth: "96px",
        "@media screen and (max-width:600px)": {
          width: "100%",
          padding: "6px 22px",
        },
        "&:focus": {
          outline: "0",
        },
      },
    },
  },
}));
